function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPythonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#3776ab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(428.423 184.256)",
    d: "M81.7 73.2c-129.9 0-121.8 56.3-121.8 56.3l.1 58.4H84v17.5H-89.2s-83.1-9.4-83.1 121.7 72.6 126.4 72.6 126.4h43.3v-60.8s-2.3-72.6 71.4-72.6h123s69.1 1.1 69.1-66.8V141.1s10.4-67.9-125.4-67.9zm-68.3 39.3c12.3 0 22.3 10 22.3 22.3s-10 22.3-22.3 22.3-22.3-10-22.3-22.3 9.9-22.3 22.3-22.3zm72 469.8c129.9 0 121.8-56.3 121.8-56.3l-.1-58.4h-124v-17.5h173.2s83.1 9.4 83.1-121.7S266.8 202 266.8 202h-43.3v60.8s2.3 72.6-71.4 72.6h-123S-40 334.3-40 402.2v112.2s-10.3 67.9 125.4 67.9zm68.4-39.3c-12.3 0-22.3-10-22.3-22.3s10-22.3 22.3-22.3 22.3 10 22.3 22.3c0 12.4-10 22.3-22.3 22.3z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python-icon.72cc2be7070e53ba7e7fe1f1b4db6b35.svg";
export { ForwardRef as ReactComponent };